import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import type { ITab, IPillTabItem, IStyledLinkStatus } from '@/components/common/types';

const PillTab = ({ children }: ITab): React.ReactElement => <Container>{children}</Container>;

const PillTabItem = ({ children, active, ...props }: IPillTabItem): React.ReactElement => {
  const activeClass = 'border-none bg-lxc-blue text-white';
  const inactiveCass = 'border bg-white text-black';

  return (
    <StyledLink {...props} status={active ? activeClass : inactiveCass}>
      {children}
    </StyledLink>
  );
};

PillTab.Item = PillTabItem;

export { PillTab };

const Container = styled.div.attrs({
  className: 'pilltab-container mb-3 w-100 h-100 scroll-snap-y py-2 overflow-auto',
})`
  scrollbar-width: none;
`;

const StyledLink = styled(Link).attrs<IStyledLinkStatus>(props => ({
  className: `
    text-sm font-medium text-decoration-none
    px-3 py-2 me-2 h-9
    scroll-snap-child
    rounded-pill cursor-pointer
    ${props.status}
  `,
}))<IStyledLinkStatus>`
  scroll-snap-align: start;
  white-space: nowrap;
  overflow-y: auto;
  color: #000;

  &:hover {
    text-decoration: none;
    color: #000;
  }
`;
